import React from 'react'
import Button from '../../../../utils/components/Button/Button'
import Input from '../../../../utils/components/Input/Input'

const CreteRole = ({formik,permissions,isEdit=false}) => {
  return (
    <div>
       <Input placeholder='Nombre del rol' name="name" onChange={formik.handleChange} value={formik.values.name} error={formik.errors.name}/>
       {
           permissions.map(permission=>(
               <div key={permission._id} className='mb-2'>
                   <input type={'checkbox'}
                   checked={formik.values.permisionsToAdd.has(permission._id)}
                   onChange={()=>{
                       const list = new Set(formik.values.permisionsToAdd)
                       if(formik.values.permisionsToAdd.has(permission._id)){
                        
                        list.delete(permission._id)
                       }else{
                        list.add(permission._id)
                       }
                       formik.setFieldValue("permisionsToAdd",list)
                 
                   }}
                   />
                   <label className='ml-2' htmlFor="">{permission.name}</label>
               </div>
           ))
       }
       {formik.errors.permisionsToAdd}
       <Button
       onClick={formik.handleSubmit}
        disabled={!formik.isValid}
        text={isEdit ? "Actualizar":'Crear'}
       />
    </div>
  )
}

export default CreteRole